import React from 'react'
import ReactDOM from 'react-dom'
import AgentMenu from './agent-menu'
import { store } from '../../store' 

$.fn.agentMenu = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(AgentMenu, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-agent-menu]').agentMenu();
});